/*
 *   File : resend-notification.js
 *   Author : https://evoqins.com
 *   Description : Resend notification modal component
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';

// custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { APIService } from '../../Service';
import { CustomSelectBox } from '../FormElements';

// custom styles
import color from '../../Style/color.scss';
import { toast } from 'react-toastify';


const ResendNotificationModal = (props) => {

    const [loader, setLoader] = useState(false);
    const [userGroupLoader, setUserGroupLoader] = useState(true);
    const [groupList, setGroupList] = useState([]);

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedOptionError, setSelectedOptionError] = useState("");
    const hasFetchedGroups = useRef(false);

    useEffect(() => {
        if (hasFetchedGroups.current) return;
        hasFetchedGroups.current = true;
        _listGroup();
    }, []);

    useEffect(() => {
        setSelectedOptionError("");
    }, [selectedOption]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("resend-notification-modal-close");
        button.click();
        props.handleClose();
    };

    // handle resend
    const _handleResend = () => {
        if (selectedOption === null) {
            setSelectedOptionError("Please select target users");
            return;
        }

        setLoader(true);
        _notificationList();
    };


    // API - Get group list
    const _listGroup = () => {
        setUserGroupLoader(true);

        let is_post = true;
        let url = 'user/user-groups';
        let request = {
            "page_num": 1,
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                let updated_list = response.data.data.map(data => ({
                    value: data.id,
                    label: data.name
                }))
                setGroupList(updated_list);
            } else {
                setGroupList([]);
            }
            setUserGroupLoader(false);
        })
    };

    
    // API - Notification list 
    const _notificationList = () => {
        let is_post = true;
        let url = 'notification/resend';
        let request = {
            "notification_id": props.notificationId,
            "user_group_id": selectedOption?.value || null
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                _handleCloseModal();
                toast.dismiss();
                toast.success("Notification resent successfully.", {
                    type: "success",
                    className: "e-toast",
                });

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoader(false);
        })
    };



    return (
        <div className="modal fade"
            id="resend-notification-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="ResendNotificationModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='resend-notification-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark padding-32px-all">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center pb-2 px-0 pt-0">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Resend Notification
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-2 pb-4 px-0'>
                        <CustomSelectBox title='Target users'
                            placeholder='Select target users'
                            controlWidth='w-100'
                            required={true}
                            height='3rem'
                            options={groupList}
                            loader={userGroupLoader}
                            isSearchable={true}
                            borderColor={`0.031rem solid ${color.arsenic}`}
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e)}
                            error={selectedOptionError} />
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-2 pb-0 px-0 gap-4'>
                        <>
                            <SecondaryButton name="Cancel"
                                paddingBlock="py-3 px-5"
                                onClick={_handleCloseModal} />
                            <PrimaryButton name="Send"
                                paddingBlock="p-3"
                                loader={loader}
                                className="w-148px"
                                onClick={_handleResend} />
                        </>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResendNotificationModal;
